import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { getBusinessPartner, getStateWiseCities } from "../../../services/userMasterUser";
import { errorMessage } from "../../../utils/alertMessage";
import { formatDate } from "../../../constants/FormateDate";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../../utils/localStorage";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";

export default function BusinessPartnerList() {

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const ds = useRef(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [stateCitiesList, setStateCitiesList] = useState([])
    const [stateCityList, setStateCityList] = useState({});

    const [stateValue, setStateValue] = useState('');
      const [cityValue, setCityValue] = useState('');

  const citiesList = stateCityList[stateValue] || [];

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    city: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    state: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    natureOfProduct: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    natureOfService: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const searchByStatusData = [

    { label: "Name", value: "name" },
    { label: "Mobile", value: "mobile" },
    { label: "City", value: "city" },
    { label: "State", value: "state" },
    { label: "Nature Of Product", value: "natureOfProduct" },
    { label: "Nature Of Service", value: "natureOfService" },
  ];

  const [searchByStatus, setSearchByStatus] = useState('name');

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    profileIn: []
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getBusinessPartner(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          if (append) {
            setProducts((prev) => [...(prev || []), ...newData]);
          } else {
            setProducts(newData);
          }

          setTotalRecords(response.data.totalRecords || newData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  useEffect(() => {

     const stateCitiesData = {
          searchBy: "",
          searchText: "",
          limit: 100000,
          offset: 0,
          sortBy: "",
          sortOrder: "desc",
          cityIn: [],
          stateIn: []
        }
    
        getStateWiseCities(stateCitiesData)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
    
              // const stateList = Object.keys(Res).map((key) => ({
              //   key
              // }));
    
              const stateListArray = Object.keys(Res);
    
              const stateList = stateListArray.map((item) => ({
                label: item,
                value: item,
              }));
    
              setStateCitiesList(stateList)
    
              setStateCityList(Res)
            } else {
              errorMessage("Invalid Credentials");
            }
          })
          .catch((err) => {
            errorMessage();
          })
          .finally(() => console.log(false));
    

    fetchData({
      ...typeData,
      limit: rows,
      offset: 0
    });
  }, []);

  useEffect(() => {
         
        const hasValidFilter =
          stateValue ||
          cityValue ;;
    
        if (!hasValidFilter) return;
    
        const payload = {
          ...typeData,
          limit: rows,
          offset: 0,
          addressInfo: { cityIn: cityValue ? cityValue : [], stateIn: stateValue ? [stateValue] : [] }
        };
    
        fetchData(payload);
    
      }, [
        stateValue,
        cityValue,
      ]);
  

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      profileIn: []
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      profileIn: []
    });
  };

  const downloadPDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 40, 15);
    doc.setFontSize(16);
    doc.text("CA User Data", 200, 15);

    doc.autoTable({
      head: [["ID", "Date", "Name", "Mobile", "City", "State", "Status"]],
      body: data.map((item) => [
        item.id,
        formatDate(item.createdDate),
        item.name,
        item.mobile,
        item.city,
        item.state,
        item.status ? "ACTIVE" : "INACTIVE"
      ]),
      startY: 25,
      theme: "grid",
      styles: { fontSize: 9 }
    });

    doc.save("CA-User-List.pdf");
  };

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  {userProfileData?.role !== "ROLE_BUSINESS_PARTNER_HANDLER" && <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/masters")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div>}
                  Business Partner List
                </h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                    <Dropdown
                      style={{ width: "100%" }}
                      value={stateValue}
                      onChange={(e) => {
                        setStateValue(e.value);
                        setCityValue([])

                      }
                      }
                      options={stateCitiesList}
                      optionLabel="label"
                      placeholder="Select a State"
                      filter
                      filterDelay={400}
                    />
                  </div>

                  <div className="col-md mb-2">
                    <MultiSelect
                      style={{ width: "100%" }}
                      value={cityValue}
                      onChange={(e) => setCityValue(e.value)}
                      options={citiesList}
                      placeholder="Select City"
                    />
                  </div>

                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 10,
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    <div className="col-md-2" style={{ alignSelf: "center" }}>
                      <Link
                        to="/user-master/business-partner/create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          // marginTop: 10,
                        }}
                      >
                        {/*<i
                          onClick={() =>
                            downloadPDF(
                              filteredProducts || products,
                              "download"
                            )
                          }
                          className="pi pi-download"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                        {/*<i
                          onClick={() =>
                            downloadPDF(filteredProducts || products, "print")
                          }
                          className="pi pi-print"
                          style={{
                            fontSize: "20px",
                            color: "#ff0101",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="name"
                        header="Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="mobile"
                        header="Mobile"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.mobile}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="emailId"
                        header="Email Id"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.emailId}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="city"
                        header="City"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.city}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="state"
                        header="state"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.state}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="profile"
                        header="Profile"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.profile}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="natureOfProduct"
                        header="Nature Of Product"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.natureOfProduct}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="natureOfService"
                        header="Nature Of Service"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.natureOfService}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.status)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-master/business-partner/edit"}
                            state={rowData}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={products}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader
                  // footer={footer} 
                  // header="Click Load Button at Footer to Load More" 
                  />
                  <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
